import { render, staticRenderFns } from "./st-main.vue?vue&type=template&id=0db38ce2&"
import script from "./st-main.vue?vue&type=script&lang=js&"
export * from "./st-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports